import { Dispatch } from 'redux';
import { RootState } from 'src/redux/reducers';
import { selectSelectedCategory } from '../selectors';
import { fetchCategoryData } from './fetchCategoryData';

const getCategoryProducts = (storeId: string, params = '') => async (dispatch: Dispatch, getState: () => RootState) => {
  const selectedCategory = selectSelectedCategory(getState());

  if (selectedCategory) {
    return await dispatch(fetchCategoryData(storeId, params));
  }
};

export default getCategoryProducts;
